var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"auto","margin-top":"1%"}},[_c('v-btn',{attrs:{"color":_vm.entity_type ==='E' ? '#f1d6fa':'#d4fcd5'},domProps:{"textContent":_vm._s(_vm.entity_value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }